import { createDateInNorwegianTime as d } from '@/services/new-utils.ts';

export const SUMMER_EXTRA_2024_CAMPAIGN_END_DATE = d(2024, 9, 16, 0);
